import { render, staticRenderFns } from "./page-dashboard.vue?vue&type=template&id=cba3a9ec&scoped=true&"
import script from "./page-dashboard.vue?vue&type=script&lang=js&"
export * from "./page-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./page-dashboard.vue?vue&type=style&index=0&id=cba3a9ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba3a9ec",
  null
  
)

export default component.exports